/**
 * Thrown for a FAILURE (or 4xx+) envelope by the services that unwrap the
 * connect-service `ApiResponse` envelope. Carries the envelope's `code` so a
 * caller can distinguish a `409` version conflict (another writer changed the
 * record since it was loaded) from any other failure without re-parsing the
 * message string.
 *
 * Being an `ApiFailureError` is also what marks a message as *server-authored*,
 * and therefore safe to show an operator — see {@link serverErrorMessage}.
 */
export class ApiFailureError extends Error {
  constructor(message: string, public readonly code?: number) {
    super(message);
    this.name = 'ApiFailureError';
  }
}

/**
 * Resolves the toastr copy for a failed call: the server's own FAILURE-envelope
 * message when `unwrap`/`throwIfFailure` produced one, otherwise the caller's
 * generic fallback. Anything else thrown (a network-level HTTP error, for
 * instance) isn't an {@link ApiFailureError} and falls back to the generic copy
 * too — its `.message` is technical, not operator-facing.
 */
export function serverErrorMessage(err: unknown, fallback: string): string {
  return err instanceof ApiFailureError && err.message ? err.message : fallback;
}
